/* 25 Jun — Marchetti product form hard reset
   The visual variant chips are now the real Shopify field: radio[name="id"].
   No hidden stale variant, no disabled options, no AJAX override.
*/
(() => {
  const radioSelector = 'form[action*="/cart/add"] .marchetti-product__variant-input[name="id"], form[action*="/cart/add"] .tiffany-product__variant-input[name="id"]';

  const updatePrice = (input) => {
    const form = input.closest('form');
    const page = form && (form.closest('.tiffany-product__details, .marchetti-product-panel') || form.closest('main') || form);
    const price = page && page.querySelector('[data-product-price]');
    if (price && input.dataset.price) price.textContent = input.dataset.price;
    const message = form && form.querySelector('[data-cart-message]');
    if (message) {
      message.hidden = true;
      message.textContent = '';
    }
  };

  const setPressed = (buttons, activeButton) => {
    buttons.forEach(button => {
      const isActive = button === activeButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const chooseSeparatedVariant = (container) => {
    const form = container.closest('form');
    if (!form) return;

    let activeLength = container.querySelector('[data-split-option="length"].is-active');
    let activeCarat = container.querySelector('[data-split-option="carat"].is-active');
    const lengthButtons = Array.from(container.querySelectorAll('[data-split-option="length"]'));
    const caratButtons = Array.from(container.querySelectorAll('[data-split-option="carat"]'));

    if (!activeLength && lengthButtons[0]) {
      activeLength = lengthButtons[0];
      setPressed(lengthButtons, activeLength);
    }
    if (!activeCarat && caratButtons[0]) {
      activeCarat = caratButtons[0];
      setPressed(caratButtons, activeCarat);
    }

    if (!activeLength || !activeCarat) return;

    const wantedLength = activeLength.dataset.splitValue;
    const wantedCarat = activeCarat.dataset.splitValue;
    const radios = Array.from(container.querySelectorAll('.marchetti-separated-variant-input[name="id"]'));
    let match = radios.find(input => !input.disabled && input.dataset.length === wantedLength && input.dataset.carat === wantedCarat);

    if (!match) {
      match = radios.find(input => !input.disabled && input.dataset.length === wantedLength) || radios.find(input => !input.disabled && input.dataset.carat === wantedCarat) || radios.find(input => !input.disabled);
      if (match) {
        const nextLength = lengthButtons.find(button => button.dataset.splitValue === match.dataset.length);
        const nextCarat = caratButtons.find(button => button.dataset.splitValue === match.dataset.carat);
        if (nextLength) setPressed(lengthButtons, nextLength);
        if (nextCarat) setPressed(caratButtons, nextCarat);
      }
    }

    if (match) {
      match.checked = true;
      updatePrice(match);
    }
  };

  const init = () => {
    document.querySelectorAll('[data-separated-variant-selector]').forEach(chooseSeparatedVariant);
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const checked = form.querySelector('.marchetti-product__variant-input[name="id"]:checked, .tiffany-product__variant-input[name="id"]:checked');
      const first = form.querySelector('.marchetti-product__variant-input[name="id"], .tiffany-product__variant-input[name="id"]');
      if (checked) updatePrice(checked);
      else if (first) {
        first.checked = true;
        updatePrice(first);
      }
    });
  };

  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches(radioSelector)) updatePrice(input);
  });

  document.addEventListener('click', event => {
    const splitButton = event.target.closest('[data-split-option][data-split-value]');
    if (splitButton) {
      const container = splitButton.closest('[data-separated-variant-selector]');
      const buttons = Array.from(container.querySelectorAll(`[data-split-option="${splitButton.dataset.splitOption}"]`));
      setPressed(buttons, splitButton);
      chooseSeparatedVariant(container);
      return;
    }

    const label = event.target.closest('label[for^="Variant-"]');
    if (!label) return;
    const input = document.getElementById(label.getAttribute('for'));
    if (input && input.matches(radioSelector)) {
      input.checked = true;
      updatePrice(input);
    }
  });

  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    const selected = form.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"]');
    const message = form.querySelector('[data-cart-message]');
    if (!selected || !selected.value) {
      event.preventDefault();
      if (message) {
        message.textContent = 'Please choose an option before adding this piece.';
        message.hidden = false;
      }
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* 25 Jun — Marchetti predictive search */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-marchetti-predictive-search]').forEach(form => {
    const input = form.querySelector('input[name="q"]');
    const results = form.querySelector('[data-marchetti-search-results]');
    if (!input || !results) return;

    let controller = null;
    let debounce = null;

    const moneyText = product => {
      if (product.price) return product.price;
      if (product.price_min) return product.price_min;
      return '';
    };

    const imageUrl = product => {
      const image = product.image || product.featured_image || product.featuredImage;
      if (!image) return '';
      if (typeof image === 'string') return image;
      return image.url || image.src || '';
    };

    const escapeHtml = text => String(text || '').replace(/[&<>\"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;'}[char] || char));

    const closeResults = () => {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    };

    const render = products => {
      if (!products.length) {
        results.innerHTML = '<div class="marchetti-search-suggestions__empty">No pieces found yet.</div>';
      } else {
        results.innerHTML = products.map(product => {
          const url = product.url || '#';
          const title = escapeHtml(product.title);
          const price = escapeHtml(moneyText(product));
          const img = imageUrl(product);
          return `
            <a class="marchetti-search-suggestions__item" href="${url}">
              <span>
                <span class="marchetti-search-suggestions__eyebrow">Marchetti piece</span>
                <span class="marchetti-search-suggestions__title">${title}</span>
                ${price ? `<span class="marchetti-search-suggestions__price">${price}</span>` : ''}
              </span>
              <span class="marchetti-search-suggestions__image">${img ? `<img src="${img}" alt="${title}" loading="lazy">` : ''}</span>
            </a>`;
        }).join('');
      }
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const fetchResults = async query => {
      if (controller) controller.abort();
      controller = new AbortController();
      const endpoint = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
      const response = await fetch(endpoint, { signal: controller.signal });
      if (!response.ok) throw new Error('Predictive search unavailable');
      const data = await response.json();
      const products = (((data || {}).resources || {}).results || {}).products || [];
      render(products);
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();
      window.clearTimeout(debounce);
      if (query.length < 2) {
        closeResults();
        return;
      }
      debounce = window.setTimeout(() => {
        fetchResults(query).catch(error => {
          if (error.name !== 'AbortError') closeResults();
        });
      }, 160);
    });

    document.addEventListener('click', event => {
      if (!form.contains(event.target)) closeResults();
    });

    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeResults();
    });
  });
});

/* 26 Jun — Account password toggle only */
document.addEventListener('click', event => {
  const button = event.target.closest('.marchetti-password-toggle');
  if (!button) return;
  const row = button.closest('.marchetti-password-row');
  const input = row && row.querySelector('input');
  if (!input) return;
  const isPassword = input.type === 'password';
  input.type = isPassword ? 'text' : 'password';
  button.textContent = isPassword ? 'Hide' : 'Show';
  button.setAttribute('aria-label', isPassword ? 'Hide password' : 'Show password');
});
